module.exports = __webpack_public_path__ + "img/logo_og.15ed6056.png";